package org.solyton.solawi.bid.application.data


val mainModales = modals

val mainActions = actions
